// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__ieDpA","spinner":"Loader_spinner__Qy86S","spin":"Loader_spin__6QF9a"};